import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

export const GENERIC_KEY_DATES_QUERY_KEY = ['genericKeyDates'];

export const useGenericKeyDates = ({
	userSession,
	meta,
}: {
	userSession: Api.UserSessionContext;
	meta?: LevStandardQueryMeta;
}) => {
	return useQuery({
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IUpcomingKeyDates>('dashboard/genericKeyDates', 'GET');
		},
		queryKey: GENERIC_KEY_DATES_QUERY_KEY,
		meta,
	});
};

export const invalidateGenericKeyDates = () =>
	reactQueryClient.invalidateQueries({ queryKey: GENERIC_KEY_DATES_QUERY_KEY });
